/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ScheduleDetailMoreActions_ScheduleFragment = { __typename: 'Schedule', id: string, allDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }> };

export const ScheduleDetailMoreActions_ScheduleFragmentDoc = gql`
    fragment ScheduleDetailMoreActions_schedule on Schedule {
  id
  allDisplays: displays {
    id
  }
  outOfSyncDisplays: displays(filter: {state: OUT_OF_SYNC}) {
    id
  }
  syncingDisplays: displays(filter: {state: SYNCING}) {
    id
  }
  removingDisplays: displays(filter: {state: REMOVING}) {
    id
  }
}
    `;